import { useEffect, useState } from "react";
import { useUpdateUserSettings, useGetUserSettings } from "../../../redux/actions/userAction";
import toastManager from "../../../components/ui/toast/ToasterManager";

/**
 * 🔧 SETTINGS CONFIG
 * Add new settings here ONLY
 */
const SETTINGS_CONFIG = [
    
  {
    key: "sms_phone_number_login",
    label: "Enable phone number login",
    description: "Allows you to loin using your phone number; it automatically comes with OTP verification via sms",
    default: false,
  },
  {
    key: "sms_withdrawal",
    label: "SMS alert for withdrawals",
    description: "Get notified when funds are withdrawn from your wallet",
    default: true,
  },
  {
    key: "sms_credit",
    label: "SMS alert for credit alerts",
    description: "Get notified when money is credited to your wallet",
    default: true,
  },
  {
    key: "sms_thrift_payments",
    label: "SMS alert for thrift payments",
    description: "Receive alerts when your your thirft is paid",
    default: false,
  },
  {
    key: "sms_loan_repayments",
    label: "SMS alert for loan repayments",
    description: "Receive alerts when your your loan is repaid",
    default: false,
  },
];

const AppSettings = () => {
  /**
   * 🔁 Build state dynamically from config
   */
  const [settings, setSettings] = useState(() =>
    SETTINGS_CONFIG.reduce((acc, item) => {
      acc[item.key] = item.default;
      return acc;
    }, {})
  );

  const updateUserSettings = useUpdateUserSettings();
  const getUserSettings = useGetUserSettings();

  const toggleSetting = (key) => {
    setSettings((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleSave = async () => {
    // 🔌 Ready-to-send payload
    const payload = { ...settings };
    const res = await updateUserSettings(payload);
    console.log(res)
    if(res.payload.data.success){
        toastManager.addToast({
            message: "Settings saved successfully",
            type: "success",
        })
    }

    console.log("Saving settings:", payload);
    // call API here
  };

 useEffect(() => {
  const fetchSettings = async () => {
    try {
      const response = await getUserSettings();

      const normalized = response.payload.data.reduce((acc, item) => {
        acc[item.key] = item.value === "true";
        return acc;
      }, {});

      setSettings(normalized);
    } catch (error) {
      console.error("Error fetching settings:", error);
    }
  };

  fetchSettings();
}, []);

  return (
    <div className="max-w-xl mx-auto bg-white rounded-2xl shadow-md border border-gray-100 p-4 sm:p-6">
      {/* Header */}
      <h1 className="text-base sm:text-lg font-semibold text-[#003399] mb-1">
        App Settings
      </h1>
      <p className="text-xs sm:text-sm text-gray-500 mb-6">
        Manage how you receive SMS notifications
      </p>

      {/* Dynamic Settings */}
      <div className="space-y-4">
        {SETTINGS_CONFIG.map((setting) => (
          <SettingRow
            key={setting.key}
            label={setting.label}
            description={setting.description}
            enabled={settings[setting.key]}
            onToggle={() => toggleSetting(setting.key)}
          />
        ))}
      </div>

      {/* Save Button */}
      <button
        onClick={handleSave}
        className="mt-6 bg-[#003399] text-white px-6 py-2 rounded-lg text-sm hover:opacity-90 transition"
      >
        Save Settings
      </button>
    </div>
  );
};

/**
 * 🔁 Reusable row component
 */
const SettingRow = ({ label, description, enabled, onToggle }) => {
  return (
    <div className="flex justify-between items-center border rounded-xl px-4 py-3">
      <div>
        <p className="text-sm font-medium text-gray-800">{label}</p>
        <p className="text-xs text-gray-500">{description}</p>
      </div>

      {/* Toggle */}
      <button
        onClick={onToggle}
        className={`w-10 h-5 rounded-full relative transition ${
          enabled ? "bg-[#ED6E0A]" : "bg-gray-300"
        }`}
        aria-pressed={enabled}
      >
        <span
          className={`absolute top-0.5 left-0.5 w-4 h-4 bg-white rounded-full transition ${
            enabled ? "translate-x-5" : ""
          }`}
        />
      </button>
    </div>
  );
};

export default AppSettings;
